import React from "react";
import { Nav, NavLink, NavMenu } from "./Navbar/NavbarElements";
import logo from "../img/logo-small.png";
import biggerLogo from "../img/logo-small-scaled-up.png"

const Navbar = ({ currentLocation}) => {
    if (currentLocation.startsWith("/admin")){
            return
    }

    switch(currentLocation){
        case "/successPage":
            return
        case "/newEntry":
            return
        case "/home":
            return
        case "/form":
            return
        case "/businessHome":
            return
        case "/accesscode":
            return
        case "/accessCode":
            return
        case "/editProfile":
            return(
                <>
                    <Nav style={{paddingBottom:"2px"}}>
                        <NavMenu style={{display:"flex", justifyContent:"space-between",paddingTop:"20px"}} >
                            <div>
                                <img src={biggerLogo} alt="Missing Logo" ></img>
                            </div>
                            <div style={{display:"flex",flexDirection:"row"}}>
                            <NavLink to="/home" activeStyle>
                                Exit
                            </NavLink>
                            </div>
                            
                        </NavMenu>
                    </Nav>
                </>
            )
        case "/about":
            return (
                <>
                    <Nav style={{position:"absolute", zIndex: 1,}}>
                        <NavMenu style={{display:"flex", justifyContent:"space-between",paddingTop:"20px"}} >
                            <div>
                            <NavLink to="/">
                                <img src={biggerLogo} alt="Missing Logo" ></img>
                            </NavLink>
                            </div>
                            <div style={{display:"flex",flexDirection:"row"}}>
                            <NavLink to="/login" activeStyle>
                                Login
                            </NavLink>
                            <NavLink to="/about" activeStyle>
                                About
                            </NavLink>
                            <NavLink to="/contactUs" activeStyle>
                                Support
                            </NavLink>
                            </div>
                            
                        </NavMenu>
                    </Nav>
                </>
            );
        case "/resources":
            return (
                <>
                    <Nav style={{paddingBottom:"2px"}}>
                        <NavMenu style={{display:"flex", justifyContent:"space-between",paddingTop:"20px"}} >
                            <div>
                            <NavLink to="/">
                                <img src={biggerLogo} alt="Missing Logo" ></img>
                            </NavLink>
                            </div>
                            <div style={{display:"flex",flexDirection:"row"}}>
                            <NavLink to="/login" activeStyle>
                                Login
                            </NavLink>
                            <NavLink to="/about" activeStyle>
                                About
                            </NavLink>
                            <NavLink to="/contactUs" activeStyle>
                                Support
                            </NavLink>
                            </div>
                            
                        </NavMenu>
                    </Nav>
                </>
            );
        default:
            return (
                <>
                    <Nav >
                        <NavMenu style={{justifyContent:"center"}}>
                            <div style={{paddingRight:200}}>
                            <NavLink to="/">
                                <img src={logo} alt="Missing Logo"></img>
                            </NavLink>
                            </div>
                            <NavLink to="/login" activeStyle>
                                Login
                            </NavLink>
                            <NavLink to="/about" activeStyle>
                                About
                            </NavLink>
                            <NavLink to="/contactUs" activeStyle>
                                Support
                            </NavLink>
                        </NavMenu>
                    </Nav>
                </>
            );
    }
};

export default Navbar;